import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as initActions from '../actions/init.actions';
import { InitSelectors } from '../selectors/init.selectors';
import { InitState } from '../state/init.state';

@Injectable({
  providedIn: 'root',
})
export class InitFacade {
  accountInfo$ = this.initSelectors.getAccountInfo$;
  isUserInfoLoaded$ = this.initSelectors.isUserInfoLoaded$;
  userId$ = this.initSelectors.getUserId$;

  constructor(
    private store: Store<InitState>,
    private initSelectors: InitSelectors,
  ) {}

  getUser(userId: number): void {
    this.store.dispatch(initActions.getUser({ userId }));
  }
}
